import { useAuth } from '../contexts/AuthContext';
import { createApiInstance } from '../utils/axiosSetup';

export const useAdminService = () => {
  const { accessToken, setAccessToken, deleteAccessToken } = useAuth();

  // Create axios instance with AuthContext callbacks
  const api = createApiInstance({
    getToken: () => accessToken,
    setToken: setAccessToken,
    getRefreshToken: () => localStorage.getItem('refreshToken'),
    clearTokens: () => {
      deleteAccessToken();
      localStorage.removeItem('refreshToken');
    }
  });

  // Admin service methods
  return {
    // Get all users
    getUsers: (page = 1, limit = 20, search = '') => {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (search) params.append('search', search);

      return api.get(`/auth/admin/users?${params.toString()}`);
    },

    // Get single user
    getUser: (id) => api.get(`/auth/admin/users/${id}`),

    // Create user
    createUser: (userData) => api.post('/auth/admin/users', userData),

    // Update user roles
    updateUserRoles: (id, roles) => 
      api.put(`/auth/admin/users/${id}/roles`, { roles }),

    // Set user password
    setUserPassword: (id, password) => 
      api.post(`/auth/admin/users/${id}/set-password`, { password }),

    // Reset user 2FA
    reset2FA: (id) => 
      api.post(`/auth/admin/users/${id}/reset-2fa`),

    // Delete user
    deleteUser: (id) => 
      api.delete(`/auth/admin/users/${id}`),

    // Restore deleted user
    restoreUser: (id) => 
      api.post(`/auth/admin/users/${id}/restore`)
  };
};
